import { render, staticRenderFns } from "./Editorbar.vue?vue&type=template&id=05e09652&"
import script from "./Editorbar.vue?vue&type=script&lang=js&"
export * from "./Editorbar.vue?vue&type=script&lang=js&"
import style0 from "./Editorbar.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports